import '../polyfill.js';
import React from 'react';
import { useState, useEffect } from 'react';
import { AppBar, Box, Button, Container, Link, Grid, Paper, IconButton, Typography } from '@mui/material';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';



import { Document, Page, pdfjs } from 'react-pdf';
import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";


// pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//   "pdfjs-dist/build/pdf.worker.min.mjs",
//   import.meta.url,
// ).toString();

//pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.mjs`;


const SchoolCalendar = () => {

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setPageNumber(1);
  };

  const goToPrevPage = () => setPageNumber((prev) => Math.max(prev - 1, 1));
  const goToNextPage = () =>
    setPageNumber((prev) => (numPages ? Math.min(prev + 1, numPages) : prev));


return (
  <>
    <Box sx={{ height: '100px' }}></Box>
    <Grid container spacing={0} alignItems="left" justify="left">
      <Grid item xs={2} />
      <Grid item xs={8}>
        <Card>
          <CardHeader title='School Calendar'/>
          <CardContent>
            <Box textAlign={'left'}>
              <Link href={`/documents/TriCLS-School-Calendar.pdf`} color="primary" underline="none">
                School Calendar (PDF Download)
              </Link>
            </Box>

            <br />
            <Box textAlign={'left'}>
              <div>
                <button onClick={goToPrevPage}>Prev</button>
                <button onClick={goToNextPage}>Next</button>
                <Typography variant="caption" align="center">
                  Page {pageNumber} of {numPages}
                </Typography>
              </div>
            </Box>
            {/* <Box textAlign={'left'} >
              <div >
                <Document file="documents/TriCLS-School-Calendar.pdf" onLoadSuccess={onDocumentLoadSuccess} >
                  <Page pageNumber={pageNumber} scale={1.50}/>
                </Document>
              </div>
            </Box> */}
            <Box textAlign={'left'} >
              <div >
                <Document file="/documents/TriCLS-School-Calendar.pdf" 
                  onLoadSuccess={onDocumentLoadSuccess} 
                  onLoadError={(error) => console.error("PDF Fail details:", error)}
                  >
                  <Page pageNumber={pageNumber} scale={1.50}/>
                </Document>
              </div>
            </Box>            
            <Box textAlign={'left'}>
              <div>
                <button onClick={goToPrevPage}>Prev</button>
                <button onClick={goToNextPage}>Next</button>
                <Typography variant="caption" align="center">
                  Page {pageNumber} of {numPages}
                </Typography>
              </div>
            </Box>

          </CardContent>
        </Card>

        </Grid> 
        <Grid item xs={2} />
      </Grid>

    <Box sx={{ height: '80px' }}></Box>
  </>
  );
}


export default SchoolCalendar